module.exports = __webpack_public_path__ + "static/media/logo.f01d49ca.svg";